import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Pax } from './Pax'

export const ListOfPaxValidation = z.object({
  list: z.instanceof(Pax, { message: 'list is required' }).array(),
})

export class ListOfPax extends Model {
  static create({ list }: z.infer<typeof ListOfPaxValidation>) {
    ListOfPaxValidation.parse({ list })
    return new ListOfPax(list)
  }

  static default() {
    return ListOfPax.create({ list: [Pax.defaultPax()] })
  }

  static fromQueryParams({ adults, children }: { adults: string; children?: string }) {
    const adultsArray = adults.split(',').filter(Boolean)
    const childrenArray = children?.split('!').filter(Boolean)

    const list = adultsArray.map((adult, index) =>
      Pax.create({
        adults: Number(adult),
        children: childrenArray?.[index]?.split(',').map(Number) ?? [],
      })
    )

    return ListOfPax.create({ list })
  }

  static empty() {
    return new ListOfPax([])
  }

  constructor(private readonly _list: Pax[]) {
    super()
  }

  get list() { return this._list } // prettier-ignore

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }
}
